import { JSX } from 'react';
import { Placeholder, useSitecoreContext, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { TabsContent } from '@ahc-digital/component-library';
import { TAB_CONTENT_CONTAINER_VALUE } from 'src/shared/static';
import { N08TabProps } from './N08Tabs.types';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: N08TabProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return isEditing ? (
    <div className="component-content">
      <Text field={props?.fields?.TabTitle} />
      {props?.rendering && (
        <Placeholder name={TAB_CONTENT_CONTAINER_VALUE} rendering={props?.rendering} />
      )}
    </div>
  ) : (
    <TabsContent value={props?.rendering?.uid || ''} data-component={marketingRenderingName}>
      {props?.rendering && (
        <Placeholder name={TAB_CONTENT_CONTAINER_VALUE} rendering={props?.rendering} />
      )}
    </TabsContent>
  );
};

export default checkDatasourceForRendering<N08TabProps>(Default);
